import { Component } from 'react';
import styled, { css } from 'styled-components';
import { fontSize } from '../../../../../common/css/setting/variable';

interface IProps {
  isCurrent: boolean;
  name: string;
  url?: string;
  dataClParams: string;
  onclick?: () => void;
}

const InputCommonStyle = css<{ $isCurrent: boolean }>`
  display: block;
  min-width: calc(2em + 16px);
  padding: 8px 10px;
  font-size: ${fontSize.px12};
  text-align: center;
  cursor: pointer; /* hrefが空の場合でもpointerにする */
  background: ${props => props.theme.news.palette.bg_lv2_common};

  &:hover {
    background: ${props => props.theme.news.palette.bg_lv1_common};
  }

  /* 現在のタブ */
  ${({ $isCurrent }) =>
    $isCurrent
      ? css`
          font-weight: bold;
          color: ${props => props.theme.news.palette.text_base_common};
          text-decoration: none;
          cursor: default;
          background-color: ${props => props.theme.news.palette.bg_lv1_common};
          border-bottom: 1px solid ${props => props.theme.riff.palette.base};

          &:hover {
            text-decoration: none;
          }
        `
      : css`
          color: ${props => props.theme.news.palette.link_pc};
        `}
`;

const Link = styled.a<{ $isCurrent: IProps['isCurrent'] }>`
  ${InputCommonStyle}
`;

const Button = styled.button<{ $isCurrent: IProps['isCurrent'] }>`
  ${InputCommonStyle}
`;

const Item = styled.li`
  padding: 0;
  border-top: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};
  border-right: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};

  &:first-of-type {
    border-left: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};
  }
`;

export default class TabItemBlock extends Component<IProps> {
  /**
   *
   */
  public render() {
    return (
      <Item>
        {this.props.url ? (
          <Link href={this.props.url} data-cl-params={this.props.dataClParams} $isCurrent={this.props.isCurrent}>
            {this.props.name}
          </Link>
        ) : (
          <Button
            data-cl-params={this.props.dataClParams}
            onClick={() => {
              if (this.props.onclick) {
                this.props.onclick();
              }
            }}
            $isCurrent={this.props.isCurrent}
          >
            {this.props.name}
          </Button>
        )}
      </Item>
    );
  }
}
